module.exports = __webpack_public_path__ + "img/item013.7873ccf6.png";